// title
// image

import { Box } from "@mui/material";
import { PageFull } from "./Pages";
import SectionTitle from "./SectionTitle";

export default function Image({ title, img }) {
    return (
        <PageFull>
            <SectionTitle title={title}/>
                <Box
                    component='img'
                    alt={title}
                    src={img}
                    sx={{
                        borderRadius: {
                            md: '20px'
                        }
                    }}
                />
        </PageFull>
    );
}